// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gM4M","icon":"styles_icon__3j5aD"};